// Angular
import { Component, Input } from '@angular/core';
import { MessageEditComponent } from 'src/app/views/pages/apps/timeline/messages/message-edit/message-edit.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SendEmailFaxComponent } from 'src/app/views/pages/apps/timeline/send-email-fax/send-email-fax.component';
import { MeetingEditComponent } from 'src/app/views/pages/apps/timeline/meetings/meeting-edit/meeting-edit.component';
import { ChooseTemplateDialogComponent } from 'src/app/views/pages/calendar/choose-template/choose-template.dialog.component';
import { DocumentListComponent } from '../../../../pages/documents-management/components';

@Component({
  selector: 'kt-quick-action',
  templateUrl: './quick-action.component.html',
})
export class QuickActionComponent {
  // Public properties

  // Set icon class name
  @Input() icon = 'flaticon2-gear';

  // Set true to icon as SVG or false as icon class
  @Input() useSVG: boolean;

  // Set bg image path
  @Input() bgImage: string;

  // Set skin color, default to light
  @Input() skin: 'light' | 'dark' = 'light';

  /**
   * Component constructor
   */
  constructor(public dialog: MatDialog) {}

  newMeeting() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '95vw';
    dialogConfig.data = { mode: 'create' };
    this.dialog.open(MeetingEditComponent, dialogConfig);
  }

  newEmailFax(type) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = { communicationType: type, sendDocs: false };
    this.dialog.open(SendEmailFaxComponent, dialogConfig);
  }

  newMessage() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '40vw';
    this.dialog.open(MessageEditComponent, dialogConfig);
  }

  sendDocuments() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = { communicationType: 'DOCUMENT', sendDocs: true };
    this.dialog.open(SendEmailFaxComponent, dialogConfig);
  }

  shareDocument(event: Event): void {
    event.stopPropagation();

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '95vw';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.data = { docShareView: true };

    this.dialog.open(DocumentListComponent, dialogConfig);
  }

  createTask() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '30vw';
    this.dialog.open(ChooseTemplateDialogComponent, dialogConfig);
  }
}
